const RouteScrollToTop = () => {
  return null;
};

export default RouteScrollToTop;